module.exports = __webpack_public_path__ + "img/ParlamiDiMare-3.b4c5ae58.jpeg";